import React, { useState, useEffect } from "react";
import "../styles/Header.css";

function Header({ handleNav }) {
  const [screenWidth, setScreenWidth] = useState(0);

  useEffect(() => {
    setScreenWidth(window.innerWidth);
    console.log(screenWidth);
  }, [screenWidth]);

  return (
    <div className="header__nav" id="header">
      {/* TITLE */}
      <div className="header__title">
        <h1>Alexander {screenWidth < 600 && <br />} Dean</h1>
      </div>

      {/* CAPTION */}
      <div className="header__caption">
        <h3>Software Engineer</h3>
        <h4 style={{ marginLeft: "5%" }}>Web and Mobile App Development</h4>
      </div>
    </div>
  );
}

export default Header;
